/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaCancelOrderInfoVo
 */
export interface KoreaCancelOrderInfoVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof KoreaCancelOrderInfoVo
     */
    orderId?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof KoreaCancelOrderInfoVo
     */
    orderCode?: string;
    /**
     * 货位
     * @type {Array<string>}
     * @memberof KoreaCancelOrderInfoVo
     */
    locations?: Array<string>;
    /**
     * SKU编码
     * @type {string}
     * @memberof KoreaCancelOrderInfoVo
     */
    skuCode?: string;
    /**
     * 图片URL
     * @type {string}
     * @memberof KoreaCancelOrderInfoVo
     */
    imgUrl?: string;
    /**
     * 回库数量
     * @type {number}
     * @memberof KoreaCancelOrderInfoVo
     */
    returnedGoodsNum?: number;
    /**
     * 包装规格
     * @type {string}
     * @memberof KoreaCancelOrderInfoVo
     */
    packageSpec?: string;
}

/**
 * Check if a given object implements the KoreaCancelOrderInfoVo interface.
 */
export function instanceOfKoreaCancelOrderInfoVo(value: object): value is KoreaCancelOrderInfoVo {
    return true;
}

export function KoreaCancelOrderInfoVoFromJSON(json: any): KoreaCancelOrderInfoVo {
    return KoreaCancelOrderInfoVoFromJSONTyped(json, false);
}

export function KoreaCancelOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaCancelOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'returnedGoodsNum': json['returnedGoodsNum'] == null ? undefined : json['returnedGoodsNum'],
        'packageSpec': json['packageSpec'] == null ? undefined : json['packageSpec'],
    };
}

export function KoreaCancelOrderInfoVoToJSON(json: any): KoreaCancelOrderInfoVo {
    return KoreaCancelOrderInfoVoToJSONTyped(json, false);
}

export function KoreaCancelOrderInfoVoToJSONTyped(value?: KoreaCancelOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'locations': value['locations'],
        'skuCode': value['skuCode'],
        'imgUrl': value['imgUrl'],
        'returnedGoodsNum': value['returnedGoodsNum'],
        'packageSpec': value['packageSpec'],
    };
}

